/*
 * A bare relative time: "3 min ago", "2 hours ago".
 *
 * SHARED, because three screens need it and decision 322 is the reason all three
 * do: `AsOf` owns the two staleness CALIBRATIONS and phrases itself as a complete
 * sentence about an OBSERVATION ("Checked for updates N ago"), which fits a
 * freshness footer and fits nothing else. A timestamp that records something a
 * PERSON did, or one that already has a label supplying the verb, needs the bare
 * phrase instead — otherwise the row reads with two verbs for one fact.
 *
 * It reuses AsOf's own elapsed-time bucketing rather than reimplementing it, so
 * the two never disagree about when "1 hour ago" becomes "2 hours ago". Still a
 * <time>, so the exact instant travels with the phrase.
 */

import { useTranslation } from "react-i18next";

import { elapsedKey, minutesSince } from "../lib/staleness";

export function Ago({ at }: { at: string }) {
  const { t } = useTranslation();
  const { key, count } = elapsedKey(minutesSince(at));
  return <time dateTime={at}>{t(key, { count })}</time>;
}
